import { Route } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { limitReportPowerDetails } from '@backoffice-frontend/limit-report/ui-power';

export const limitReportPowerRoute: Route = {
  path: '',
  children: [
    {
      path: '',
      loadChildren: () =>
        import('@backoffice-frontend/limit-report/ui-power').then(
          (mod) => mod.LimitReportPowerListModule
        ),
    },
    limitReportPowerDetails,
  ],
};
